import * as React from "react";
import "./index.css";
import ModalBase from "../../ModalBase";
import { OutlinedInput } from "../../../Input";
import Button from "../../../Button";
import { useDispatch } from "react-redux";
import { changePassword } from "../../../../features/auth/authSlice";

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [formState, setFormState] = React.useState({
    currentPassword: "",
    password: "",
    confirmPassword: "",
  });

  const dispatch = useDispatch();



  const handleFieldChange = (e) =>
    setFormState({ ...formState, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(changePassword({
      oldPassword: formState.currentPassword,
      newPassword: formState.password,
    }));
    onClose();
  };

  return (
    <ModalBase isOpen={isOpen} setIsOpen={onClose} title="Change Password">
      <form onSubmit={onSubmit} className="change-pass-modal-base">
        <span className="change-pass-modal-title">Change Password</span>
        <OutlinedInput
          value={formState.currentPassword}
          name="currentPassword"
          onChange={handleFieldChange}
          title="Current Password"
          type={"password"}
        />
        <OutlinedInput
          value={formState.password}
          name="password"
          onChange={handleFieldChange}
          title="New Password"
          type={"password"}
        />
        <OutlinedInput
          value={formState.confirmPassword}
          name="confirmPassword"
          onChange={handleFieldChange}
          title="Confirm Password"
          type={"password"}
        />
        <button className="change-password-btn" type="submit">
          Change Password
        </button>
      </form>
    </ModalBase>
  );
};

export default ChangePasswordModal;
